module.exports = __webpack_public_path__ + "static/media/facebook.7d13a05b.png";